export default {
    items: [
        {
            name: 'Dashboard',
            url: '/dashboard/',
            icon: 'antsicon-dashboard'
        },
        {
            name: 'Communication',
            url: '/communication/',
            icon: 'antsicon-message',
            children: [
                {
                    name: 'Template',
                    url: '/communication/template/list/',
                },
                {
                    name: 'Sender',
                    url: '/communication/sender/list/',
                },
            ]
        },
        {
            name: 'People',
            url: '/people/',
            icon: 'antsicon-people',
            children: [
                {
                    name: 'Tag',
                    url: '/people/tag/',
                },
                {
                    name: 'Blacklist',
                    url: '/people/blacklist/',
                },
            ]
        },
        {
            name: 'Report',
            url: '/report/',
            icon: 'antsicon-report',
            children: [
                {
                    name: 'Log',
                    url: '/report/log/',
                }
            ]
        },
        {
            name: 'OTP',
            url: '/otp/configuration/',
            icon: 'antsicon-otp',
        },
        {
            name: 'Contact Us',
            url: '/contactus/',
            icon: 'antsicon-issue-report'
        }
    ]
};


// WEBPACK FOOTER //
// ./src/components/Sidebar/_nav.js


// WEBPACK FOOTER //
// ./src/components/Sidebar/_nav.js